import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../api/admin';
import { format } from 'date-fns';
import './TablePage.css';

const STATUS_LABELS: Record<string, string> = {
  pending: '대기중',
  delivered: '전달됨',
  viewed: '확인함',
  guessed: '픽 완료',
  awaiting_result: '결과대기',
  matched: '매칭성공',
  failed: '매칭실패',
  expired: '만료',
};

const PHASE_LABELS: Record<string, string> = {
  none: '-',
  hint: '힌트',
  message_1: '메시지1',
  message_2: '메시지2',
  message_3: '메시지3',
  full: '전체공개',
};

export default function PicksPage() {
  const [picks, setPicks] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const data = await adminApi.getPicks(page, 20, statusFilter || undefined);
    setPicks(data.data);
    setTotal(data.total);
    setTotalPages(data.totalPages);
    setLoading(false);
  }, [page, statusFilter]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="table-page">
      <div className="page-header">
        <h2>픽 관리 <span className="count">({total.toLocaleString()})</span></h2>
        <div className="filter-group">
          <select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}>
            <option value="">전체 상태</option>
            {Object.entries(STATUS_LABELS).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>보낸사람</th>
              <th>받는사람</th>
              <th>힌트</th>
              <th>상태</th>
              <th>공개단계</th>
              <th>생성일</th>
              <th>만료일</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} className="center">로딩 중...</td></tr>
            ) : picks.length === 0 ? (
              <tr><td colSpan={7} className="center">데이터 없음</td></tr>
            ) : picks.map((p) => (
              <tr key={p.id} onClick={() => navigate(`/picks/${p.id}`)} className="clickable">
                <td>{p.pickerPhone}</td>
                <td>{p.pickedContactName}<br/><small>{p.pickedPhone}</small></td>
                <td>{p.hintText}</td>
                <td><span className={`badge ${p.status}`}>{STATUS_LABELS[p.status] || p.status}</span></td>
                <td>{PHASE_LABELS[p.revealPhase] || p.revealPhase}</td>
                <td>{format(new Date(p.createdAt), 'MM-dd HH:mm')}</td>
                <td>{format(new Date(p.expiresAt), 'MM-dd HH:mm')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>이전</button>
        <span>{page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>다음</button>
      </div>
    </div>
  );
}
